import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PROVIDER_LIST = 'GET_PROVIDER_LIST';
export const GET_PROVIDER_LIST_SUCCESS = 'GET_PROVIDER_LIST_SUCCESS';
export const GET_PROVIDER_LIST_FAILURE = 'GET_PROVIDER_LIST_FAILURE';

// Action Creators
export const getProviderList = () => ({
  type: GET_PROVIDER_LIST,
});

export const getProviderListSuccess = (users) => ({
  type: GET_PROVIDER_LIST_SUCCESS,
  payload: users,
});

export const getProviderFailure = (error) => ({
  type: GET_PROVIDER_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getProviderListData = (
  external,
  pageCount,
  countryValue,
  stateValue,
  cityValue,
  titleValue,
  isInternal,
  appointmentId
) => {
  return async (dispatch) => {
    dispatch(getProviderList());

    try {
      let requestUrl = url?.getProviderList;
      const params = [];

      if (
        titleValue !== undefined &&
        !countryValue &&
        !stateValue &&
        !cityValue
      ) {
        params.push(`title_id=${titleValue}`);
      } else {
        if (pageCount !== undefined) {
          params.push(`page=${pageCount}`);
        }
        if (countryValue !== undefined) {
          params.push(`country_id=${countryValue}`);
        }
        if (stateValue !== undefined) {
          params.push(`state_id=${stateValue}`);
        }
        if (cityValue !== undefined) {
          params.push(`city_id=${cityValue}`);
        }
        if (titleValue !== undefined) {
          params.push(`title_id=${titleValue}`);
        }
      }

      if (isInternal !== undefined) {
        params.push(`is_internal=${isInternal}`);
      }
      if (appointmentId !== undefined) {
        params.push(`appointment_id=${appointmentId}`);
      }

      if (params.length > 0) {
        requestUrl += `?${params.join('&')}`;
      }

      const response = await getMethodWithToken(requestUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getProviderListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getProviderFailure(error?.message));
    }
  };
};
